<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('itemcostprice', 2) }}</div>
      <div>
        <router-link class="btn-blue" :to="'edit-itemcostprice?id='+itc_id">{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="itemcostprice"
        >{{ $t('itemcostprice') }} {{ $tc('list', 2) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('fnbitem') }} {{ $t('name') }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ selectedFnbItem }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('itemcostprice') }}}}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ costprice }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $tc('status', 1) }}</div>
              <div
                v-if="item_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >{{ $t('active') }}</div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">{{ $t('inactive') }}</div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1 ">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('createdat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedby') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">{{ $t('modifiedat') }}</div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";
import PosFnbService from "@/services/PosFnbService";

export default {
  data() {
    return {
      itc_id: "",
      itp_id: "",
      selectedFnbItem: "",
      costprice: "",
      item_is_active: "",
      created_at: "",
      created_by: "",
      updated_at: "",
      updated_by: ""
    };
  },
  beforeMount() {
    this.itp_id = this.$route.query.id;

    this.getItemCostPriceList();
  },
  methods: {
    getItemCostPriceList: function() {
      let payload = {
        itc_id: this.itp_id
      };
      // console.log("payload :", payload);
      PosFnbService.GetItemCostPriceById(payload)
        .then(response => {
          const { data } = response;
          console.log("data cost price:", data);
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            console.log("obj :", obj);
            this.costprice = obj.itc_cost_price;
            this.created_at = obj.created_at;
            this.created_by = obj.created_by;
            this.item_is_active = obj.itc_is_active;
            this.update_at = obj.update_at;
            this.update_by = obj.update_by;

            this.getCinemaList(obj.cinema_id);
            this.getFnbItems(obj.item_id);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },

    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map(x => {
              if (String(cine_id) === String(x.cine_id)) {
                this.selectedCinema = x.cine_name;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getFnbItems: function(id) {
      let payload = {
        limit: null,
        currentPage: null
      };
      PosFnbService.GetAllFnBItems(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.fnb_items = data.Records;
            this.fnb_items.map(x => {
              if (String(id) === String(x.item_id)) {
                this.selectedFnbItem = x.recipe_name;
                this.itc_id = id;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/ItemCostPriceComponents/viewItemCostPrice.vue